import { useEffect, useState } from "react";
import ImagePreview from "./ImagePreview";
import "../styles/Question.css";

const KNOWLEDGE_CHOICES = [
  "a",
  "b",
  "c",
  "d",
];

export default function Question({
  q,
  u,
  updateResponse,
  initialValue = "",
}) {
  const [selectedOption, setSelectedOption] =
    useState(initialValue);

  useEffect(() => {
    setSelectedOption(initialValue || "");
  }, [initialValue, q.id]);

  const handleAnswerChange = (event) => {
    const value = event.target.value;

    setSelectedOption(value);

    if (
      String(q.level) === String(u?.level) &&
      typeof updateResponse === "function"
    ) {
      updateResponse(q.id, value);
    }
  };

  const isKnowledgeQuestion =
    q.question_type === "Knowledge";

  const shouldShowIdentificationQuestion =
    q.question?.trim().toLowerCase() !==
    "what is this?";

  return (
    <fieldset className="questionContainer">
      {q.question &&
        (isKnowledgeQuestion ||
          shouldShowIdentificationQuestion) && (
          <legend className="questionText">
            {q.question}
          </legend>
        )}

      {q.image && (
        <div className="questionImage">
          <ImagePreview
            base64String={q.image}
            alt={`Question ${q.id}`}
            className="fourHQuestionImage"
          />
        </div>
      )}

      {isKnowledgeQuestion ? (
        <div className="questionForm">
          {KNOWLEDGE_CHOICES.map((choice) => {
            const choiceValue =
              q[`choice_${choice}`];

            if (!choiceValue) {
              return null;
            }

            const inputId = `question-${q.id}-choice-${choice}`;

            return (
              <div
                className="radioBtnContainer"
                key={choice}
              >
                <input
                  id={inputId}
                  className="radioBtnChoice"
                  type="radio"
                  name={`questionOption-${q.id}`}
                  value={choiceValue}
                  checked={
                    selectedOption === choiceValue
                  }
                  onChange={handleAnswerChange}
                />

                <label
                  htmlFor={inputId}
                  className="choiceLabel"
                >
                  {choiceValue}
                </label>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="idFormInput">
          <label
            className="sr-only"
            htmlFor={`identification-answer-${q.id}`}
          >
            Answer for question {q.id}
          </label>

          <input
            id={`identification-answer-${q.id}`}
            className="idInput"
            type="text"
            value={selectedOption}
            onChange={handleAnswerChange}
            placeholder="Type your answer here."
            autoComplete="off"
          />
        </div>
      )}
    </fieldset>
  );
}